import { SaveButton, useNotify, useRefresh } from "react-admin";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router";
import { studentRequests } from "api/studentApi";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";

const SaveButtonStudyGroups = ({ setIsEditStudyGroups }) => {
  const notifyError = useNotifyError();
  const { getValues } = useFormContext();
  const { id } = useParams();

  const notify = useNotify();
  const refresh = useRefresh();

  const handleSaveClick = async () => {
    const formDataToSave = getValues();
    const body = {
      studyGroups: formDataToSave.studyGroups,
    };

    try {
      await dataProvider.customRequest(studentRequests.updateSessionExamStudyGroups(id), body, "PUT");
      refresh();
      notify("Данните са запазени успешно!", { type: "success" });
      setIsEditStudyGroups(false);
    } catch (e) {
      notifyError(e);
    }
  };

  return (
    <SaveButton
      label="Запази"
      onClick={handleSaveClick}
      size="small"
    />
  );
};

export default SaveButtonStudyGroups;
